export default __webpack_public_path__ + "static/media/SphereCoreMind.c9edbc9e.webp";